import { useContext } from 'react';

import { Flex, VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import service from '@/services/index';

import TaxonomyContext from '../../../context/TaxonomyContext';
import DescriptionEditor from './DescriptionEditor';
import TitleEditor from './TitleEditor';

type Props = {
  taxonomy?: TaxonomyT;
};

const TaxonomyHeader = (props: Props) => {
  const { taxonomy } = props;
  const { refetchTaxonomy } = useContext(TaxonomyContext);

  return (
    <VFlex g={4} f={1} style={{ minHeight: 84, transform: 'translate(-12px)' }}>
      <Flex a="flex-end" g={4}>
        {taxonomy && (
          <TitleEditor
            key={taxonomy.title}
            title={taxonomy.title}
            updateTitle={async (title) => {
              await service.taxonomy.editTaxonomyItem(taxonomy.alias, {
                ...taxonomy,
                title,
              });
              refetchTaxonomy();
            }}
          />
        )}
        <Typo
          type="label2"
          className="text-gray-600"
          style={{ paddingBottom: 8 }}
        >
          Taxonomy
        </Typo>
      </Flex>
      {taxonomy && (
        <DescriptionEditor
          key={taxonomy.desc}
          desc={taxonomy.desc}
          onDoneClick={async (desc) => {
            await service.taxonomy.editTaxonomyItem(taxonomy.alias, {
              ...taxonomy,
              desc: desc || '',
            });
            refetchTaxonomy();
          }}
        />
      )}
    </VFlex>
  );
};

export default TaxonomyHeader;
